/**
 * @file empty-body.component.tsx
 * @description Компонент пустого состояния таблицы для Task Manager приложения, который отображается когда в таблице отсутствуют данные для показа. Предоставляет пользователю информативное сообщение "Нет записей" в стилизованном контейнере с фоновым цветом и скругленными углами, используется как fallback-компонент в различных табличных интерфейсах приложения для улучшения пользовательского опыта при отсутствии данных.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@components/ui/base/text']
 * @related-files ['src/features/table/table.component.tsx', 'src/features/catalog/catalog.component.tsx', 'src/features/queue/queue.component.tsx']
 */

import { Text } from '@components/ui/base/text';

export const EmptyBody = () => {
    return (
        <div className="h-[5.2927vmin] rounded-[0.8468vmin] px-[1.0585vmin] bg-[#F1F5F6] flex items-center">
            <Text size="s" view="ghost">
                Нет записей
            </Text>
        </div>
    );
};
